<template>
    <v-container
        fluid
        class="px-4"
        v-if="banner">
        <v-row>
            <v-col cols="6">
                <div class="subtitle-1 font-weight-bold">
                    {{ $t('bannerList.details.updatedAt') }}
                </div>
                <div class="subtitle-2">
                    {{ banner.updatedAt ? $util.getDDMMYYYYDateFormat(banner.updatedAt) : 'No data' }}
                </div>
            </v-col>
            <detail-form
                v-model="bannerForm">
                <template v-slot:content="{ form }">
                    <detail-form-item
                        required
                        cols="6"
                        type="select"
                        v-model="form.isActive"
                        :label="$t('bannerList.details.isActive')"
                        item-value="value"
                        item-text="label"
                        :items="[
                            { value: true, label: 'Active' },
                            { value: false, label: 'Inactive' }
                        ]"/>
                    <hr class="full-width ma-4">
                    <detail-form-item
                        imageFile
                        cols="12"
                        type="file"
                        :label="$t('bannerList.details.banner')"
                        v-model="form.bannerUrl"
                        defaultDisplayFileName="Banner"
                        :preferedSize="[1125, 750]"
                    />
                    <detail-form-item
                        required
                        cols="12"
                        type="text"
                        :label="$t('bannerList.details.link')"
                        v-model="form.link" />
                </template>
            </detail-form>
        </v-row>
    </v-container>
    <div v-else/>
</template>

<script>
import DetailForm from '@/components/forms/DetailForm'
import DetailFormItem from '@/components/forms/DetailFormItem'

export default {
    name: 'BannerDetailsView',

    model: {
        prop: 'banner',
        event: 'input'
    },

    components: {
        DetailForm,
        DetailFormItem
    },

    props: {
        banner: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        bannerForm: {
            get () {
                return this.banner
            },

            set (value) {
                this.$defineEmits('input', value)
            }
        }
    },

    methods: {
        async save () {
            await this.$store.dispatch('appSettings/saveBanners', this.banner)
            await this.$store.dispatch('appSettings/fetchBanners')
        }
    }
}
</script>

<style lang="scss" scoped></style>
